import Helper from '@ember/component/helper';
import { format } from 'd3-format';
import { isEmpty } from '@ember/utils';

export function pct([number], { precision = 1, sign = '', trimZeros = false } = {}) {
  if (isNaN(number) || isEmpty(number)) {
    return '--';
  }

  // The `~` option makes d3-format strip all trailing insignificant zeros,
  // e.g. it'll turn 15.00% into 15%
  let formatter = format(`${sign}.${precision}${trimZeros ? '~' : ''}%`);
  return formatter(number);
}

/*
  Basic Usage:

  ```handlebars
  {{pct number precision=10}}
  ```
*/
export default Helper.helper(pct);
